import * as Sentry from '@sentry/react';
import { sanitizeUrl } from 'lib/sentrySanitize';

// Rotas de autenticação/senha: nunca enviam body nem data da resposta (credenciais e tokens).
const AUTH_ROUTE_PATTERN = /\/v1\/auth(\/|\?|$)|\/v1\/account\/password/i;
const OMITIDO = '[omitido: rota de autenticação]';
const HEADERS_PERMITIDOS = ['content-type', 'x-request-id'];

// Só cabeçalhos sem segredo (Authorization/Cookie/Set-Cookie nunca saem). Aceita objeto simples ou AxiosHeaders.
const pickSafeHeaders = headers => {
  if (!headers) return undefined;
  const plain = typeof headers.toJSON === 'function' ? headers.toJSON() : headers;
  const out = {};
  Object.keys(plain).forEach(key => {
    if (HEADERS_PERMITIDOS.includes(key.toLowerCase())) out[key] = plain[key];
  });
  return out;
};

const addSentryLoggingInterceptor = axiosInstance => {
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      // defesa extra: se algum interceptor anterior rejeitar com undefined/null (ver
      // handleAuthError), não deixa a desestruturação virar unhandled rejection aqui.
      if (!error) {
        return Promise.reject(error);
      }
      const { config, response } = error;

      const url = config?.url ? sanitizeUrl(String(config.url)) : config?.url;
      const isAuthRoute = AUTH_ROUTE_PATTERN.test(config?.url || '');

      const duration = new Date().getTime() - (config?.metadata?.startTime?.getTime?.() || 0);

      let errorType = 'unknown';
      if (!response) {
        errorType = 'network_error';
      } else if (response.status >= 400 && response.status < 500) {
        errorType = 'client_error';
      } else if (response.status >= 500) {
        errorType = 'server_error';
      }

      const capturedError =
        error instanceof Error
          ? error
          : new Error(error?.message || error?.statusText || `HTTP ${error?.status ?? 'unknown'}`);

      Sentry.captureException(capturedError, {
        tags: {
          endpoint: url,
          method: config?.method,
          status: response?.status,
          error_type: errorType,
        },
        contexts: {
          request: {
            url,
            method: config?.method,
            params: config?.params,
            body: isAuthRoute ? OMITIDO : config?.data,
            headers: pickSafeHeaders(config?.headers),
          },
          response: {
            status: response?.status,
            data: isAuthRoute ? OMITIDO : response?.data,
            headers: pickSafeHeaders(response?.headers),
          },
          network: {
            duration_ms: duration,
          },
        },
      });

      return Promise.reject(error);
    },
  );
};
export { addSentryLoggingInterceptor };
